<div class="na-info-cont">
  <div class="na-info-picture">
    <img class="rounded-lg" alt="Element Not Available" src="{{ media_path }}{{ not_available_picture }}" />
  </div>
  <ddc-text-gradient
    class="dashboard-header-txt text-xl"
    [_text]="'No ' + _elem + ' Available Yet !'"
    [_type]="'1'"
  ></ddc-text-gradient>
</div>
